var Glyphicon = require("components/utility/icons/Glyphicon");
var ImageIcon = require("components/utility/icons/ImageIcon");

var StandardIcon = function(props) {
	if (props.type == StandardIcon.WR_ICON) {
		return <ImageIcon { ...props } />

	} else if (props.type == StandardIcon.WR_SIMPLE_ICON) {
		return <ImageIcon { ...props } icon={ props.icon + "-s" } />

	} else if (props.type == StandardIcon.GLYPHICON) {
		return <Glyphicon { ...props } />

	} else {
		return <span />;
	}
}

StandardIcon.GLYPHICON = "Glyphicon";
StandardIcon.WR_ICON = "WR Icon";
StandardIcon.WR_SIMPLE_ICON = "WR Small Icon";

StandardIcon.propTypes = StrictPropTypes({
	// Passed through (this other props) to the child icon component
	className: PropTypes.string,

	// Icon name
	icon: PropTypes.string.isRequired,

	// Type of icon
	type: PropTypes.oneOf([StandardIcon.GLYPHICON,
		StandardIcon.WR_ICON, StandardIcon.WR_SIMPLE_ICON]).isRequired
});

module.exports = StandardIcon;



// WEBPACK FOOTER //
// ./modules/components/utility/icons/StandardIcon.js